/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<g _fill="#004CD0" fill-rule="nonzero"><path pid="0" d="M12.978 0A12.96 12.96 0 000 12.978a12.956 12.956 0 0012.978 12.978 12.956 12.956 0 0012.978-12.978A12.96 12.96 0 0012.978 0zm0 24.22A11.218 11.218 0 011.735 12.979 11.218 11.218 0 0112.978 1.735a11.218 11.218 0 0111.243 11.243A11.218 11.218 0 0112.978 24.22z"/><path pid="1" d="M10.992 7.27c-.521 0-.864.344-.864.865v9.686c0 .521.343.864.864.864a.862.862 0 00.864-.864V8.135c0-.521-.35-.864-.864-.864zM14.97 7.27c-.52 0-.864.344-.864.865v9.686c0 .521.343.864.865.864.52 0 .864-.343.864-.864V8.135c0-.521-.35-.864-.864-.864z"/></g>'
  }
})
